import { useState } from "react";
import { Download, Instagram, Facebook, Loader2, Radio } from "lucide-react";
import { VIDEOS } from "./VideosQueHacenDinero";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" {...props}>
    <path d="M16.6 5.82s.51.5 0 0A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.59 2.59 0 0 1 0-5.18c.27 0 .53.04.77.13V9.66a6.04 6.04 0 0 0-.77-.05 5.7 5.7 0 0 0 0 11.4 5.7 5.7 0 0 0 5.7-5.7V8.27a7.34 7.34 0 0 0 4.3 1.38V6.56s-1.44.07-3.06-.74z" />
  </svg>
);

const PlatformBadges = () => (
  <div className="flex items-center gap-2">
    {[
      { Icon: Instagram, label: "Instagram" },
      { Icon: Facebook, label: "Facebook" },
      { Icon: TikTokIcon, label: "TikTok" },
    ].map(({ Icon, label }) => (
      <span key={label} title={label} className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white/10 border border-white/15 text-white/80">
        <Icon />
      </span>
    ))}
  </div>
);

export const MoneyVideosSection = () => {
  const [downloading, setDownloading] = useState(null);

  const handleDownload = async (v) => {
    setDownloading(v.id);
    try {
      const res = await fetch(v.url);
      const blob = await res.blob();
      const href = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = href;
      a.download = v.filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(href);
    } catch {
      window.open(v.url, "_blank");
    } finally {
      setDownloading(null);
    }
  };

  return (
    <section className="max-w-6xl mx-auto px-4 py-10" data-testid="money-videos-section">
      <div className="text-center mb-6">
        <div className="inline-flex items-center gap-2 bg-red-600/90 text-white px-3 py-1.5 rounded-full text-xs font-black uppercase tracking-wider mb-3">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white" />
          </span>
          Comerciales en vivo hoy
        </div>
        <h2 className="text-2xl md:text-4xl font-black text-white leading-tight mb-2">
          Videos que <span className="text-[#80C753]">hacen dinero</span>
        </h2>
        <p className="text-slate-300 text-sm md:text-base max-w-2xl mx-auto">
          Los comerciales que están funcionando ahora mismo en redes. Míralos y descárgalos para tus campañas.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {VIDEOS.map((v) => (
          <div key={v.id} data-testid={`academia-video-card-${v.id}`} className="bg-[#11162a] rounded-2xl border border-white/10 overflow-hidden flex flex-col hover:border-[#80C753]/40 transition-colors">
            <div className="relative bg-black">
              <span className="absolute top-3 left-3 z-10 inline-flex items-center gap-1.5 bg-red-600 text-white px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-wider shadow">
                <Radio className="h-3 w-3" /> En vivo
              </span>
              <video
                data-testid={`academia-video-player-${v.id}`}
                src={v.url}
                controls
                playsInline
                preload="metadata"
                className="w-full aspect-[9/16] max-h-[460px] object-contain bg-black"
              />
            </div>
            <div className="p-5 flex flex-col flex-1">
              <div className="flex items-center justify-between gap-2 mb-2">
                <h3 className="text-white font-black text-lg leading-tight">{v.title}</h3>
                <PlatformBadges />
              </div>
              <p className="text-slate-400 text-sm mb-4 flex-1">{v.desc}</p>
              <button
                type="button"
                data-testid={`academia-video-download-${v.id}`}
                onClick={() => handleDownload(v)}
                disabled={downloading === v.id}
                className="w-full inline-flex items-center justify-center gap-2 bg-[#80C753] hover:bg-[#6fb145] text-white font-bold px-4 py-3 rounded-xl text-sm uppercase tracking-wide disabled:opacity-60 transition-colors"
              >
                {downloading === v.id ? (
                  <><Loader2 className="h-4 w-4 animate-spin" /> Descargando...</>
                ) : (
                  <><Download className="h-4 w-4" /> Descargar comercial</>
                )}
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MoneyVideosSection;
